import React from "react";
import { BookOpen } from "lucide-react";
import { TransformedProfileData } from "@/types/publicProfile";
import { Section } from "./Section";

interface BlogSectionProps {
  blogPosts: TransformedProfileData["sections"]["blog"]["items"];
}

export const BlogSection: React.FC<BlogSectionProps> = ({ blogPosts }) => {
  return (
    <Section
      id="blog"
      title="Blog & Articles"
      icon={<BookOpen className="h-5 w-5" />}
    >
      <div className="grid gap-4 md:grid-cols-2">
        {blogPosts
          .filter((post) => post.privacy.isVisible)
          .map((post) => (
            <article key={post.id} className="card-apple p-5">
              {post.coverImage && (
                <div className="mb-4 overflow-hidden rounded-lg">
                  <img
                    src={post.coverImage}
                    alt={post.title}
                    className="h-32 w-full object-cover"
                  />
                </div>
              )}
              <div className="flex items-start justify-between mb-2">
                <h3 className="text-base font-semibold">{post.title}</h3>
                {post.featured && (
                  <span className="pill-apple text-xs bg-yellow-100 text-yellow-800">
                    Featured
                  </span>
                )}
              </div>
              <p className="text-sm text-secondary mb-3">{post.excerpt}</p>
              <div className="flex items-center justify-between text-xs text-tertiary mb-3">
                <span>{new Date(post.publishDate).toLocaleDateString()}</span>
                {post.readTime && <span>{post.readTime} min read</span>}
              </div>
              <div className="flex flex-wrap gap-2 mb-3">
                {post.tags &&
                  post.tags.map((tag: string) => (
                    <span key={tag} className="pill-apple text-xs">
                      {tag}
                    </span>
                  ))}
              </div>
              {post.url && (
                <a
                  href={post.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-xs text-primary hover:underline"
                >
                  Read Article
                </a>
              )}
            </article>
          ))}
      </div>
    </Section>
  );
};
